// 直投聚合客保审核 - Mock 数据
// 仅用于前端联调前展示页面，后端就绪后将 USE_MOCK 置为 false 即可切回真实接口。
// 返回结构与 req.Apis.customer.aggregation.groupList / budgetBind.log / budgetExpire / budgetBind.review 保持一致。

// 审核状态：1=待审核 2=已驳回 3=已通过
// 进入方式：0=新创建 1=公海认领
// 客保状态：1=默认保护 2=修改期保护 3=正式保护

const MOCK_RECORDS = [
  // ===== 待审核 7 条 =====
  {
    id: 2001,
    group_id: 2001,
    budget_name: '北京九子信',
    identify_code: '北京九子信科技有限公司',
    owner_name: '王海涛',
    is_claim: 1,
    start_time: '2026-08-18',
    audit: 0,
    protect_status: 1,
    end_time: '2026-09-17',
    remaining_days: 1,
  },
  {
    id: 2002,
    group_id: 2002,
    budget_name: '厦门南荟南',
    identify_code: '厦门南荟南科技有限公司',
    owner_name: '王海涛',
    is_claim: 0,
    start_time: '2026-09-10',
    audit: 0,
    protect_status: 1,
    end_time: '2026-10-10',
    remaining_days: 25,
  },
  {
    id: 2003,
    group_id: 2003,
    budget_name: '醒图直投',
    identify_code: '深圳市脸萌科技有限公司',
    owner_name: '徐菁菁',
    is_claim: 1,
    start_time: '2026-09-12',
    audit: 0,
    protect_status: 1,
    end_time: '2026-10-12',
    remaining_days: 26,
  },
  {
    id: 2004,
    group_id: 2004,
    budget_name: '河马畅听直投',
    identify_code: '北京立达智胜科技有限公司',
    owner_name: '张林霞',
    is_claim: 0,
    start_time: '2026-09-13',
    audit: 0,
    protect_status: 1,
    end_time: '2026-10-13',
    remaining_days: 28,
  },
  {
    id: 2005,
    group_id: 2005,
    budget_name: '西安麦穗',
    identify_code: '西安麦穗互动科技有限公司',
    owner_name: '徐菁菁',
    is_claim: 1,
    start_time: '2026-09-14',
    audit: 0,
    protect_status: 1,
    end_time: '2026-10-14',
    remaining_days: 28,
  },
  {
    id: 2006,
    group_id: 2006,
    budget_name: '上海星禾',
    identify_code: '上海星禾网络科技有限公司',
    owner_name: '陈晨',
    is_claim: 0,
    start_time: '2026-09-15',
    audit: 0,
    protect_status: 1,
    end_time: '2026-10-15',
    remaining_days: 30,
  },
  {
    id: 2007,
    group_id: 2007,
    budget_name: '深圳云帆',
    identify_code: '深圳云帆信息技术有限公司',
    owner_name: '陈晨',
    is_claim: 0,
    start_time: '2026-09-16',
    audit: 0,
    protect_status: 1,
    end_time: '2026-10-16',
    remaining_days: 30,
  },
  // ===== 已驳回 3 条 =====
  {
    id: 2008,
    group_id: 2008,
    budget_name: '郑州创运',
    identify_code: '郑州创运科技有限公司',
    owner_name: '张林霞',
    is_claim: 1,
    start_time: '2026-09-08',
    audit: 2,
    protect_status: 2,
    end_time: '2026-09-25',
    remaining_days: 4,
  },
  {
    id: 2009,
    group_id: 2009,
    budget_name: '厦门场量',
    identify_code: '厦门场量影视传媒有限公司',
    owner_name: '李明',
    is_claim: 0,
    start_time: '2026-09-07',
    audit: 2,
    protect_status: 2,
    end_time: '2026-09-24',
    remaining_days: 3,
  },
  {
    id: 2010,
    group_id: 2010,
    budget_name: '北京趣芯合',
    identify_code: '北京趣芯合科技有限公司',
    owner_name: '陈晨',
    is_claim: 0,
    start_time: '2026-09-06',
    audit: 2,
    protect_status: 2,
    end_time: '2026-09-23',
    remaining_days: 2,
  },
  // ===== 已通过 6 条 =====
  {
    id: 2011,
    group_id: 2011,
    budget_name: '杭州前景',
    identify_code: '杭州前景信息科技有限公司',
    owner_name: '陈晨',
    is_claim: 0,
    start_time: '2026-08-20',
    audit: 1,
    protect_status: 3,
    end_time: '2027-02-20',
    remaining_days: 152,
  },
  {
    id: 2012,
    group_id: 2012,
    budget_name: '广州拓达',
    identify_code: '广州拓达网络科技有限公司',
    owner_name: '王海涛',
    is_claim: 1,
    start_time: '2026-08-15',
    audit: 1,
    protect_status: 3,
    end_time: '2027-02-15',
    remaining_days: 147,
  },
  {
    id: 2013,
    group_id: 2013,
    budget_name: '成都云栖',
    identify_code: '成都云栖科技有限公司',
    owner_name: '徐菁菁',
    is_claim: 0,
    start_time: '2026-08-10',
    audit: 1,
    protect_status: 3,
    end_time: '2027-02-10',
    remaining_days: 142,
  },
  {
    id: 2014,
    group_id: 2014,
    budget_name: '武汉星辰',
    identify_code: '武汉星辰网络科技有限公司',
    owner_name: '张林霞',
    is_claim: 1,
    start_time: '2026-08-05',
    audit: 1,
    protect_status: 3,
    end_time: '2027-02-05',
    remaining_days: 137,
  },
  {
    id: 2015,
    group_id: 2015,
    budget_name: '长沙悦动',
    identify_code: '长沙悦动信息科技有限公司',
    owner_name: '陈晨',
    is_claim: 0,
    start_time: '2026-07-28',
    audit: 1,
    protect_status: 3,
    end_time: '2027-01-28',
    remaining_days: 129,
  },
  {
    id: 2016,
    group_id: 2016,
    budget_name: '重庆卓远',
    identify_code: '重庆卓远信息科技有限公司',
    owner_name: '王海涛',
    is_claim: 0,
    start_time: '2026-07-20',
    audit: 1,
    protect_status: 3,
    end_time: '2027-01-20',
    remaining_days: 121,
  },
];

// 可变副本：审核操作会就地修改状态，便于交互演示
const db = MOCK_RECORDS.map((item) => ({ ...item }));

const MOCK_LOGS = [
  {
    id: 1,
    operation_time: '2026-09-16 14:30',
    budget_name: '杭州前景',
    identify_code: '杭州前景信息科技有限公司',
    operation_info: '默认客保到期，进入公海',
    operator: '系统',
  },
  {
    id: 2,
    operation_time: '2026-09-16 11:20',
    budget_name: '西安麦穗',
    identify_code: '西安麦穗互动科技有限公司',
    operation_info: '修改资料，重新提交审核',
    operator: '徐菁菁',
  },
  {
    id: 3,
    operation_time: '2026-09-16 10:05',
    budget_name: '郑州创运',
    identify_code: '郑州创运科技有限公司',
    operation_info: '审核驳回，进入修改期',
    operator: '陈晨',
  },
  {
    id: 4,
    operation_time: '2026-09-16 09:40',
    budget_name: '深圳云帆',
    identify_code: '深圳云帆信息技术有限公司',
    operation_info: '新建聚合，发起客保审核',
    operator: '陈晨',
  },
  {
    id: 5,
    operation_time: '2026-09-15 17:12',
    budget_name: '厦门场量',
    identify_code: '厦门场量影视传媒有限公司',
    operation_info: '审核驳回，进入修改期',
    operator: '李明',
  },
  {
    id: 6,
    operation_time: '2026-09-15 16:30',
    budget_name: '上海星禾',
    identify_code: '上海星禾网络科技有限公司',
    operation_info: '新建聚合，发起客保审核',
    operator: '陈晨',
  },
  {
    id: 7,
    operation_time: '2026-09-15 15:18',
    budget_name: '西安麦穗',
    identify_code: '西安麦穗互动科技有限公司',
    operation_info: '审核驳回，进入修改期',
    operator: '李明',
  },
  {
    id: 8,
    operation_time: '2026-09-15 14:02',
    budget_name: '北京趣芯合',
    identify_code: '北京趣芯合科技有限公司',
    operation_info: '审核驳回，进入修改期',
    operator: '陈晨',
  },
  {
    id: 9,
    operation_time: '2026-09-15 11:45',
    budget_name: '南京时光',
    identify_code: '南京时光网络科技有限公司',
    operation_info: '正式客保到期，进入公海',
    operator: '系统',
  },
  {
    id: 10,
    operation_time: '2026-09-15 10:30',
    budget_name: '郑州创运',
    identify_code: '郑州创运科技有限公司',
    operation_info: '公海认领，发起客保审核',
    operator: '张林霞',
  },
  {
    id: 11,
    operation_time: '2026-09-14 16:20',
    budget_name: '成都云栖',
    identify_code: '成都云栖科技有限公司',
    operation_info: '审核通过，进入正式客保',
    operator: '陈晨',
  },
  {
    id: 12,
    operation_time: '2026-09-13 09:50',
    budget_name: '广州拓达',
    identify_code: '广州拓达网络科技有限公司',
    operation_info: '公海认领，发起客保审核',
    operator: '王海涛',
  },
];

function toNum(value) {
  const n = Number(value);
  return Number.isNaN(n) ? undefined : n;
}

function includesText(target, keyword) {
  if (!keyword) return true;
  return String(target || '')
    .toLowerCase()
    .includes(String(keyword).toLowerCase());
}

function delay(data, ms = 200) {
  return new Promise((resolve) => setTimeout(() => resolve(data), ms));
}

function filterRecords(params = {}) {
  let list = db.slice();
  if (
    params.audit !== undefined &&
    params.audit !== '' &&
    params.audit !== null &&
    Number(params.audit) !== -1
  ) {
    const status = toNum(params.audit);
    list = list.filter((item) => Number(item.audit) === status);
  }
  if (params.budget_name) {
    list = list.filter((item) =>
      includesText(item.budget_name, params.budget_name),
    );
  }
  if (params.identify_code) {
    list = list.filter((item) =>
      includesText(item.identify_code, params.identify_code),
    );
  }
  if (params.owner_name) {
    list = list.filter((item) =>
      includesText(item.owner_name, params.owner_name),
    );
  }
  if (
    params.is_claim !== undefined &&
    params.is_claim !== '' &&
    params.is_claim !== null
  ) {
    const is_claim = toNum(params.is_claim);
    list = list.filter((item) => Number(item.is_claim) === is_claim);
  }
  if (
    params.protect_status !== undefined &&
    params.protect_status !== '' &&
    params.protect_status !== null
  ) {
    const protect = toNum(params.protect_status);
    list = list.filter((item) => Number(item.protect_status) === protect);
  }

  return list;
}

// 模拟 groupList 响应
export function mockGroupList(params = {}) {
  const all = filterRecords(params);
  const countsBase = filterRecords({ ...params, audit: -1 });
  const counts = {
    pending: countsBase.filter((item) => Number(item.audit) === 0).length,
    rejected: countsBase.filter((item) => Number(item.audit) === 2).length,
    approved: countsBase.filter((item) => Number(item.audit) === 1).length,
    all: countsBase.length,
  };
  const total = all.length;
  const page = Math.max(Number(params.page) || 1, 1);
  const pageSize = Math.max(Number(params.page_size) || 10, 1);
  const start = (page - 1) * pageSize;
  const list = all.slice(start, start + pageSize);
  return delay({ code: 200, data: { total, list, counts } });
}

// 模拟 budgetBind.log 响应
export function mockLog(params = {}) {
  let list = MOCK_LOGS.slice();
  if (params.budget_name) {
    list = list.filter((item) =>
      includesText(item.budget_name, params.budget_name),
    );
  }
  if (params.start_date && params.end_date) {
    list = list.filter((item) => {
      const day = String(item.operation_time).slice(0, 10);
      return day >= params.start_date && day <= params.end_date;
    });
  }
  const total = list.length;
  const page = Math.max(Number(params.page) || 1, 1);
  const pageSize = Math.max(Number(params.page_size) || 10, 1);
  const start = (page - 1) * pageSize;
  const paged = list
    .slice(start, start + pageSize)
    .map((item) => ({ ...item }));
  return delay({ code: 200, data: { total, list: paged } });
}

// 模拟 budgetExpire 响应（3 天内将到期的客保）
export function mockExpire() {
  const list = db
    .filter((item) => Number(item.remaining_days) <= 3)
    .map((item) => ({
      id: item.id,
      budget_name: item.budget_name,
      release_time: item.end_time,
      remaining_days: item.remaining_days,
    }));
  return delay({ code: 200, data: { total: list.length, list } });
}

// 模拟 budgetBind.review 响应：就地更新审核状态
export function mockReview(params = {}) {
  const id = Number(params.id);
  const target = db.find((item) => Number(item.id) === id);
  if (target) {
    target.audit = Number(params.audit);
    const now = new Date();
    const timestamp = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    target.review_time = timestamp;
    target.review_operator = params.operator || '当前用户';
    if (Number(params.audit) === 2) {
      // 驳回 -> 进入修改期
      target.protect_status = 2;
      target.reason = params.reason || '';
      const deadline = new Date();
      deadline.setDate(deadline.getDate() + 2);
      target.end_time = `${deadline.getFullYear()}-${String(deadline.getMonth() + 1).padStart(2, '0')}-${String(deadline.getDate()).padStart(2, '0')}`;
      MOCK_LOGS.unshift({
        operation_time: timestamp,
        budget_name: target.budget_name,
        identify_code: target.identify_code,
        operation_info: '审核驳回，进入修改期',
        operator: target.review_operator,
      });
    } else if (Number(params.audit) === 1) {
      target.protect_status = 3;
      target.end_time = params.end_time || target.end_time;
      target.note = params.note || '';
      MOCK_LOGS.unshift({
        operation_time: timestamp,
        budget_name: target.budget_name,
        identify_code: target.identify_code,
        operation_info: '审核通过，正式客保生效',
        operator: target.review_operator,
      });
    }
    target.remaining_days = Math.max(0, Math.ceil((new Date(`${target.end_time}T23:59:59`) - now) / 86400000));
  }
  return delay({ code: 200, data: { id } });
}

// 模拟调整客保期响应：更新正式客保到期时间
export function mockAdjustDeadline(params = {}) {
  const id = Number(params.id);
  const target = db.find((item) => Number(item.id) === id);
  if (target) {
    if (params.end_time) {
      const before = target.end_time;
      target.end_time = params.end_time;
      target.changes = [{ label: '正式到期时间', before, after: params.end_time }];
      MOCK_LOGS.unshift({
        operation_time: new Date().toLocaleString('sv-SE').slice(0, 16),
        budget_name: target.budget_name,
        identify_code: target.identify_code,
        operation_info: `调整正式客保期限：${before} → ${params.end_time}`,
        operator: params.operator || '当前用户',
      });
    }
    if (target.end_time) {
      const diff = Math.ceil((new Date(`${target.end_time}T23:59:59`) - new Date()) / 86400000);
      target.remaining_days = diff > 0 ? diff : 0;
    }
  }
  return delay({ code: 200, data: { id } });
}
